<div class="section" *ngIf="data.length !== 0">
  <div class="title">Дисквалификации и не допуски</div>
  <mtg-data-slider>
    <mtg-data-slider-item *ngFor="let item of data">
      <div class="user-card">
        <div class="photo">
          <a [routerLink]="getUserRoute(item.user.leaguePlayer.id)" queryParamsHandling="preserve">
            <img [src]="item.user.leaguePlayer.photo.path" *ngIf="item.user.leaguePlayer.photo.path" class="circle-image"/>
            <div class="empty-photo" *ngIf="!item.user.leaguePlayer.photo.path">
              {{ item.user.leaguePlayer.initials }}
            </div>
          </a>
        </div>
        <div class="info">
          <a [routerLink]="getUserRoute(item.user.leaguePlayer.id)" queryParamsHandling="preserve">
            <h4>
              {{ item.user.leaguePlayer.shortName }}<span
              class="text-muted">&nbsp;{{item.user.teamUser.number ? '#&nbsp;' + item.user.teamUser.number : ''}}</span>
            </h4>
            <div class="text-highlight" *ngIf="item.disqualification.id">
              Дисквалифицикрован с {{ item.disqualification.dateFrom | date : 'dd.MM.yyyy' }}
              <ng-container *ngIf="item.disqualification.dateTo">
                до {{ item.disqualification.dateTo | date: 'dd.MM.yyyy' }}
              </ng-container>
              <ng-container *ngIf="item.disqualification.matchesCount">
                на {{ item.disqualification.matchesCount | pluralize: ['матч', 'матча', 'матчей'] }}
              </ng-container>
              <div
                *ngIf="item.disqualification.reason"
                class="text-muted"
              >{{ item.disqualification.reason }}</div>
            </div>
            <div class="text-highlight" *ngIf="item.conditionalDisqualification.id">
              Условно дисквалифицикрован с {{ item.conditionalDisqualification.dateFrom | date : 'dd.MM.yyyy' }}
              <ng-container *ngIf="item.conditionalDisqualification.dateTo">
                до {{ item.conditionalDisqualification.dateTo | date: 'dd.MM.yyyy' }}
              </ng-container>
              <ng-container *ngIf="item.conditionalDisqualification.matchesCount">
                на {{ item.conditionalDisqualification.matchesCount | pluralize: ['матч', 'матча', 'матчей'] }}
              </ng-container>
              <div
                *ngIf="item.conditionalDisqualification.reason"
                class="text-muted"
              >{{ item.conditionalDisqualification.reason }}</div>
            </div>
            <div class="text-highlight" *ngIf="item.limitations">
              Не допущен
              <div class="text-muted">
                <ng-container *ngIf="item.limitations.minGoalkeeperUserGamesCount || item.limitations.minGoalkeeperUserTime">
                  <div *ngIf="item.limitations.minGoalkeeperUserGamesCount">Недостаточно игр</div>
                  <div *ngIf="item.limitations.minGoalkeeperUserTime">Недостаточно игрового времени</div>
                </ng-container>
                <ng-container *ngIf="!item.limitations.minGoalkeeperUserGamesCount && !item.limitations.minGoalkeeperUserTime">
                  <div *ngIf="item.limitations.minUserGamesCount">Недостаточно игр</div>
                  <div *ngIf="item.limitations.minUserTime">Недостаточно игрового времени</div>
                </ng-container>
              </div>
            </div>
            <div class="text-highlight" *ngIf="!item.haveDocuments || item.haveNoPersonalInfo">
              Не допущен
              <ng-container *ngIf="item.haveNoPersonalInfo">
                <div class="text-muted" *ngIf="!item.user.leaguePlayer.photo.path">Нет фото</div>
                <div class="text-muted" *ngIf="!item.user.leaguePlayer.rating && item.user.teamUser.user.hockeyProfile.position !== hockeyPositions.goaltender">Нет индекса</div>
              </ng-container>
              <div class="text-muted" *ngIf="!item.haveDocuments">Отсутствуют заявочные документы</div>
            </div>
          </a>
        </div>
      </div>
    </mtg-data-slider-item>
  </mtg-data-slider>
</div>


